import { render, staticRenderFns } from "./insureSuccess.vue?vue&type=template&id=12fc6f82&"
import script from "./insureSuccess.vue?vue&type=script&lang=js&"
export * from "./insureSuccess.vue?vue&type=script&lang=js&"
import style0 from "./insureSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports